module.exports = __webpack_public_path__ + "img/risk_title.ae348b50.png";